import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../components/Layout';
import Content from '../../../components/Pages/Emails/Create';

const { displayName } = config;

function EmailCreate(): React.JSX.Element {
  document.title = `${displayName}: Создать рассылку`;

  return (
    <Layout>
      <Content />
    </Layout>
  );
}

export default EmailCreate;
